import React, { Component } from "react";
import {  Loader, Icon, Message, Tab, Header, Form, Table, Select, Input, Dropdown, List, Button, Modal, Divider, Checkbox} from 'semantic-ui-react'

import { exporttoJSON } from "../libs/sharedFunctions";
import _ from 'lodash';
import ReactJson from "react-json-view";

const dataTypes=[
  {key: 'varchar', value: 'varchar', text: 'Text'}, 
  {key: 'decimal', value: 'decimal', text: 'Number'}, 
  {key: 'bit', value: 'bit', text: 'Boolean'}, 
]
const orchestrationMethods=[
  {key: 'sgcore.application.smart.orchestrationupdatesuppliername', value: 'sgcore.application.smart.orchestrationupdatesuppliername', text: 'SRV3.4 Update Supplier Name'}, 
  {key: 'sgcore.application.smart.orchestrationsetdeviceconfigmpxn', value: 'sgcore.application.smart.orchestrationsetdeviceconfigmpxn', text: 'SRV6.20.1 Set Device Config (MPxN)'}, 
  {key: 'sgcore.application.smart.orchestrationrequesthandoverofdccdevice', value: 'sgcore.application.smart.orchestrationrequesthandoverofdccdevice', text: 'SRV6.21 Request Handover of DCC Controlled Device (ESME/GSME)'}, 
  {key: 'sgcore.application.smart.orchestrationrequesthandoverofgpf', value: 'sgcore.application.smart.orchestrationrequesthandoverofgpf', text: 'SRV6.21 Request Handover of GPF'}, 
  {key: 'sgcore.application.smart.orchestrationcommissiondevice', value: 'sgcore.application.smart.orchestrationcommissiondevice', text: 'SRV8.1.1 Commission Device'}, 
  {key: 'sgcore.application.smart.orchestrationupdatehanlog', value: 'sgcore.application.smart.orchestrationupdatehanlog', text: 'SRV8.11 Update HAN Log (Join)'}, 
  {key: 'sgcore.application.smart.orchestrationupdatehanlogremovedevice', value: 'sgcore.application.smart.orchestrationupdatehanlogremovedevice', text: 'SRV8.11 Update HAN Log (Unjoin)'}, 
  {key: 'sgcore.application.smart.orchestrationcommshubupdateinstallnosmwan', value: 'sgcore.application.smart.orchestrationcommshubupdateinstallnosmwan', text: 'SRV8.14.2 Communications Hub Status Update – Install No SM WAN'}, 
  {key: 'sgcore.application.smart.orchestrationdecommissiondevice', value: 'sgcore.application.smart.orchestrationdecommissiondevice', text: 'SRV8.3 Decommission Device'}, 
  {key: 'sgcore.application.smart.orchestrationjoingsmetogpf', value: 'sgcore.application.smart.orchestrationjoingsmetogpf', text: 'SRV8.7.2 Join GSME to GPF'}, 
  {key: 'sgcore.application.smart.orchestrationcheckwancoverage', value: 'sgcore.application.smart.orchestrationcheckwancoverage', text: 'SRV12.1 Request WAN Matrix'}, 
  {key: 'sgcore.application.smart.orchestrationsendd0367installandleave', value: 'sgcore.application.smart.orchestrationsendd0367installandleave', text: 'Send D0367 - Install and Leave'}, 
]

  const timeoutUnits=[
    {key: 'minutes', value: 'minutes', text: 'minutes'}, 
    {key: 'hours', value: 'hours', text: 'hours'}, 
    {key: 'days', value: 'days', text: 'days'}, 
  ]

  const eventTypes=[
    {key: 801, value: 801, text: 'Service Request Failed'}, 
    {key: 802, value: 802, text: 'DCC Response'}, 
    {key: 804, value: 804, text: 'DCC Alert'}, 
    {key: 807, value: 807, text: 'Device Response'}, 
  ]

  const eventEntities=[
    {key: "smartdevice", value: "smartdevice", text: "Smart Device"}, 
    {key: "orchestration", value: "orchestration", text: "Orchestration"}
  ]
  
  const smartDevices=[
    {key: "smartdeviceid", value: "smartdeviceid", text: "ESME/GSME"}, 
    {key: "chfsmartdeviceid", value: "chfsmartdeviceid", text: "CHF"},
    {key: "gpfsmartdeviceid", value: "gpfsmartdeviceid", text: "GPF"},
  ]

  const eventOutcomes=[
    {key: "success", value: "success", text: "Success"}, 
    {key: "fail", value: "fail", text: "Failure"}
  ]
  
  const newEvent={entity: 'smartdevice', entityinstanceidfield: 'smartdeviceid', eventid: 801, criteria: {request$servicereferencevariant: ''}, outcome: 'fail', action: 'orchestrationfail', notificationdata: {}}

export default class SmartOrchestrationDefinition extends Component {
  constructor(props) {
    super(props);
    this.state={data: {description: '', datarequirements:[], editEvent: false, editStepKey: null, editEventIndex: null, selectedField: null}}
    
  }

  componentDidMount() {
    this.setState({data: this.props.data, selectedField: null, selectedStep: null});
  }
  componentWillReceiveProps(nextProps)
  {
    if (this.props.name!==nextProps.name)
    {
      this.setState({data: nextProps.data, selectedField: null, selectedStep: null});
    }
  }

  updateDataRequirement(fieldName, fieldProperty, value) {
    var copyData=_.cloneDeep(this.state.data);
    copyData.datarequirements[fieldName][fieldProperty]=value;
    this.setState({data: copyData})
    this.props.onDataChange(copyData);
  }

  updateDescription (value) {
    var copyData=_.cloneDeep(this.state.data);
    copyData.description=value;
    this.setState({data: copyData})
    this.props.onDataChange(copyData);
  }
    updateProcessStep(stepKey, property, value) {
      var copyData=_.cloneDeep(this.state.data);
      copyData.steps[stepKey][property]=value;
      this.setState({data: copyData})  
      this.props.onDataChange(copyData);}

    updateEvent(stepKey, eventIndex,  property, value) {
      var copyData=_.cloneDeep(this.state.data);
        copyData.steps[stepKey].events[eventIndex][property]=value;
        this.setState({data: copyData})
        this.props.onDataChange(copyData);  }
    
  eventDescription(event) {
    if (event.eventid===801) return "DCC Rejection - SRV"+event.criteria.request$servicereferencevariant
    else if (event.eventid===802) return "DCC Response - SRV"+event.criteria.request$servicereferencevariant
    else if (event.eventid===804) return "DCC Alert - "+event.criteria.dccalertcode
    else if (event.eventid===807) return "Device Response - SRV"+event.criteria.servicereferencevariant
  }
  eventText(event) {
    if (event.action==="orchestrationfail") return "Orchestration Failure"
    else if (event.action==="orchestrationsuccess") return "Orchestration Success"
    else if (event.action.startsWith('goto ')) return "Go to step "+event.action.split(' ')[1]
    else if (event.action==="retry") return "Retry (up to " + event.retrycount + " times)"
  }
  eventIcon(event) {
    if (event.outcome==="success") return "check"
    else return "x"
  }

  addEvent(stepKey) {
    var copyData=_.cloneDeep(this.state.data);
    copyData.steps[stepKey].events.push(_.cloneDeep(newEvent));
    this.setState({data: copyData, editEvent: true, editStepKey: stepKey, editEventIndex: copyData.steps[stepKey].events.length-1})  
    this.props.onDataChange(copyData);}

  deleteEvent(stepKey, index) {
    var copyData=_.cloneDeep(this.state.data);
    copyData.steps[stepKey].events.splice(index, 1);
    this.setState({data: copyData})
    this.props.onDataChange(copyData);
  }

  validEvent(event) {
    if ((event.eventid===801 || event.eventid===802) && !(event.criteria.request$servicereferencevariant && this.validSRV(event.criteria.request$servicereferencevariant)) ) return false
    if ((event.eventid===804) && !(event.criteria.dccalertcode && event.criteria.dccalertcode.startsWith('N'))) return false
    if ((event.eventid===807) && !(event.criteria.servicereferencevariant && this.validSRV(event.criteria.servicereferencevariant)) ) return false
    return true;
  }

  addField() {
    var copyData=_.cloneDeep(this.state.data);
    const fieldName=prompt("Enter field name");
    copyData.datarequirements[fieldName]={type: 'varchar', length: 10, nullable: true};
    this.setState({data: copyData})
    this.props.onDataChange(copyData);
  }

  deleteField(index) {
    var copyData=_.cloneDeep(this.state.data);
    copyData.datarequirements.splice(index, 1);
    this.setState({data: copyData});
    this.props.onDataChange(copyData);
  }

  addStep() {
    var copyData=_.cloneDeep(this.state.data);
    var newKey=(Object.keys(copyData.steps).length+1).toString();
    copyData.steps[newKey]={description: '', method: 'sgcore.application.smart.orchestrationupdatesuppliername', parameters: ['$orchestrationid'], timeout: '1 hours', ontimeout: 'orchestrationfail', onfail: 'orchestrationfail', 'events':[]};
    this.setState({data: copyData})
    this.props.onDataChange(copyData);
  }

  deleteStep(key) {
    var copyData=_.cloneDeep(this.state.data);
    delete copyData.steps[key];
    this.setState({data: copyData});
    this.props.onDataChange(copyData);
  }


  validSRV(srv) {
    // SRV should numbers separated by dots
    const parseSRV = srv.split('.');
    if (parseSRV.length===0)
    return false
    parseSRV.forEach((srvFragment) => {if (isNaN(parseInt(srvFragment))) return false})
    return true;
  }



 render() {
  const panes = [
    { menuItem: {key: 'Data Requirements', content: 'Data Requirements', icon: 'edit'}, render: () => <Tab.Pane>
      <Button className='seaglassbutton' onClick={()=>{this.addField()}}><Icon name='add'/>Add</Button>
      <Button className='seaglassbutton' disabled={this.state.selectedField===null} onClick={()=>{this.deleteField(this.state.selectedField)}}><Icon name='x'/>Delete</Button>
        <Table celled selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Field Name</Table.HeaderCell>
            <Table.HeaderCell>Data Type</Table.HeaderCell>
            <Table.HeaderCell>Length</Table.HeaderCell>
            <Table.HeaderCell>Precision</Table.HeaderCell>
            <Table.HeaderCell>Scale</Table.HeaderCell>
            <Table.HeaderCell>Required</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.keys(this.state.data.datarequirements).map((fieldName, index) => {
            const dataRequirement=this.state.data.datarequirements[fieldName]
            return (
            <Table.Row key={index} active={this.state.selectedField===index} onClick={(cell)=>{this.setState({selectedField: index})}}>
              <Table.Cell>{fieldName}</Table.Cell>
              <Table.Cell>{<Select fluid options={dataTypes} value={dataRequirement.type} onChange={(event, data) =>{this.updateDataRequirement(fieldName, 'type', data.value)} }/> }</Table.Cell>
              <Table.Cell>{dataRequirement.type==='varchar' && <Input required fluid type='number' step="1" value={dataRequirement.length} onChange={(event, data) =>{this.updateDataRequirement(fieldName, 'length', data.value)} }/> }</Table.Cell>
              <Table.Cell>{dataRequirement.type==='decimal' && <Input required fluid type='number' step="1" value={dataRequirement.precision} onChange={(event, data) =>{this.updateDataRequirement(fieldName, 'precision', data.value)} }/> }</Table.Cell>
              <Table.Cell>{dataRequirement.type==='decimal' && <Input required fluid type='number' step="1" value={dataRequirement.scale} onChange={(event, data) =>{this.updateDataRequirement(fieldName, 'scale', data.value)} }/> }</Table.Cell>
              <Table.Cell>{<Checkbox checked={!dataRequirement.nullable} onChange={(event, data) =>{this.updateDataRequirement(fieldName, 'nullable', !data.checked)} }/> }</Table.Cell>
              
            </Table.Row>)
          }
            )}
        </Table.Body>
        </Table>
      </Tab.Pane> },
    { menuItem: {key: 'Process', content: 'Process', icon: 'list'}, render: () => <Tab.Pane>
      <Button className='seaglassbutton' onClick={()=>{this.addStep()}}><Icon name='add'/>Add</Button>
      <Button className='seaglassbutton' disabled={this.state.selectedStep===null} onClick={()=>{this.deleteStep(this.state.selectedStep)}}><Icon name='x'/>Delete</Button>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>#</Table. HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
            <Table.HeaderCell>Timeout</Table.HeaderCell>
            <Table.HeaderCell>Outcomes</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.keys(this.state.data.steps).map((key, index) => {
            const step=this.state.data.steps[key]
            return (
            <Table.Row key={key} active={this.state.selectedStep===key} onClick={(cell)=>{this.setState({selectedStep: key})}}>
              <Table.Cell>{key}</Table.Cell>
              <Table.Cell width={4}>{<Input fluid value={step.description} onChange={(event, data) =>{this.updateProcessStep(key, 'description', data.value)} }/> }</Table.Cell>
              <Table.Cell width={4}>{<Select fluid options={orchestrationMethods} value={step.method} onChange={(event, data) =>{this.updateProcessStep(key, 'method', data.value)} }/> }</Table.Cell>
              <Table.Cell width={2}>
      
      

                {<Input fluid label={
                <Dropdown options={timeoutUnits} value={step.timeout.split(' ')[1]} onChange={(event, data) =>{this.updateProcessStep(key, 'timeout', step.timeout.split(' ')[0]+' '+data.value)} }/> 
                } labelPosition='right' value={step.timeout.split(' ')[0]} onChange={(event, data) =>{this.updateProcessStep(key, 'timeout', data.value+' '+step.timeout.split(' ')[1])} }/> }
                

              </Table.Cell>
              <Table.Cell>
                <List>
                  {step.events.map((event, index) => {
                    return (
                    <List.Item key={index}>
                      <List.Icon name={this.eventIcon(event)} />
                      <List.Content>

                        <List.Header><a onClick={()=>{this.setState({editEvent:true, editStepKey: key, editEventIndex: index})}}>{this.eventDescription(event)}</a></List.Header>
                        <List.Description>{this.eventText(event)}<a onClick={()=>{this.deleteEvent(key,index)}}> delete</a></List.Description>
                      </List.Content>
                    </List.Item>)
                  })}
                </List>
                <a onClick={()=>{this.addEvent(key)}}>add new</a>
              </Table.Cell>
              
            </Table.Row>)
          }
            )}
        </Table.Body>
        </Table>
    </Tab.Pane> }
  ]
  var event;
  var eventActions;
  if (this.state.editEvent)
  {
    event=this.state.data.steps[this.state.editStepKey].events[this.state.editEventIndex];
    eventActions=[
      {key: "orchestrationsuccess", value: "orchestrationsuccess", text: "Orchestration Success"}, 
      {key: "orchestrationfail", value: "orchestrationfail", text: "Orchestration Failure"}, 
      {key: "retry", value: "retry", text: "Retry"}
    ]
    Object.keys(this.state.data.steps).filter(key=>{return key !==this.state.editStepKey}).forEach(key=>{eventActions.push({key: 'goto '+key, value: 'goto '+key, text: 'Go to step '+key})})
  
  }
return (
  <div>
    <Form>
    <Form.Input fluid label='Description' placeholder='Description' value={this.state.data.description} onChange={(event, data) =>{this.updateDescription(data.value)} }/>
    </Form>
    <Divider/>
  <Tab menu={{tabular: true, attached: 'top' }} panes={panes} />
{event && <Modal open={this.state.editEvent}>
        <Modal.Header size='tiny'>
        <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="edit"/>{this.eventDescription(event)}</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Header as='h4'>Trigger Event</Header>
        <Form.Select label="Entity" placeholder="Entity" required options={eventEntities} value={event.entity} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'entity', data.value)}}/>
        {event.entity==="smartdevice" && <Form.Select label="Device Type" placeholder="Device Type" required options={smartDevices} value={event.entityinstanceidfield} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'entityinstanceidfield', data.value)}}/>}
        <Form.Select label="Event Type" placeholder="Event Type" required options={eventTypes} value={event.eventid} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'eventid', data.value)}}/>
        {(event.eventid===801 || event.eventid===802) && <Form.Input label="SRV" placeholder="SRV" required value={event.criteria.request$servicereferencevariant} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'criteria', {request$servicereferencevariant: data.value})}}/>}
        {event.eventid===804 && <Form.Input label="Alert Code" placeholder="Alert Code" required  value={event.criteria.dccalertcode} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'criteria', {dccalertcode: data.value})}}/>}
        {event.eventid===807 && <Form.Input label="SRV" placeholder="SRV" required value={event.criteria.servicereferencevariant} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'criteria', {servicereferencevariant: data.value, responsecode: 'I0'})}}/>}
        <Header as='h4'>Action</Header>
        <Form.Select label="Action" placeholder="Action" required options={eventActions} value={event.action} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'action', data.value)}}/>
        {event.action==="retry" && <Form.Input type="number" step="1" label="Retry Count" placeholder="Retry Count" required value={event.retrycount} onChange={(event, data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'retrycount', data.value)}}/>}
        <Header as='h4'>Notification Data</Header>
        <ReactJson src={event.notificationdata} name={false} collapsed={false} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} theme={this.props.darkmode ? "summerfruit" : "summerfruit:inverted"} onEdit={(data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'notificationdata', data.updated_src)}} onAdd={(data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'notificationdata', data.updated_src)}} onDelete={(data)=>{this.updateEvent(this.state.editStepKey, this.state.editEventIndex, 'notificationdata', data.updated_src)}}/>
        
        <Divider/>
        <Button className="seaglassbutton" disabled={!this.validEvent(event)} onClick={()=>{this.setState({editEvent: false, editStepKey: null, editEventIndex: null})}}>Save</Button>
        </Form>
        </Modal.Content>
        </Modal>  }
        </div>
);  


    }
  }